"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bidinfo = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const actions = require("../../actionTypes/bidinfo");
exports.initialState = {
    status: 'STANDBY',
    bidinfo: null,
    error: fp.option.none
};
const bidLens = monocle.Lens.fromProp('bidinfo');
const statusLens = monocle.Lens.fromProp('status');
const errorLens = monocle.Lens.fromProp('error');
const methods = {};
methods[actions.BID_STATUS_REQUEST] = (state, action) => fp.function.compose(statusLens.set('CHECKING_STATUS'), errorLens.set(fp.option.none))(state);
methods[actions.BID_STATUS_REQUEST_SUCCESS] = (state, action) => fp.function.compose(bidLens.set(action.payload.bidinfo), statusLens.set('STATUS_CHECKED'))(state);
methods[actions.BID_STATUS_REQUEST_FAILURE] = (state, action) => statusLens.set('FAILED')(state);
methods[actions.UPDATE_VALIDATION] = (state, action) => {
    return fp.function.compose(errorLens.set(fp.option.some(action.payload.validation.reduce((rv, x) => {
        ;
        (rv[x.key] = rv[x.key] || []).push(x.value);
        return rv;
    }, {}))), statusLens.set('FAILED'))(state);
};
methods[actions.CLEAR] = () => (Object.assign({}, exports.initialState));
const bidinfo = (state = exports.initialState, action) => {
    const fn = methods[action.type];
    if (fn) {
        return fn(state, action);
    }
    return state;
};
exports.bidinfo = bidinfo;
//# sourceMappingURL=index.js.map